<template>
  <div id="listTokens">
    <vs-table :max-items="itemsPerPage" pagination search :data="_mapListTokens" stripe>
      <template slot="header">
        <div class="rounded-full py-3 px-6 mb-3 md:mb-0 bg-white border-color m-auto md:m-0">
          <vs-dropdown>
            <a class="flex items-center" href.prevent>
              {{ itemsPerPage }} of {{ _mapListTokens.length }}
              <i class="material-icons"> expand_more </i>
            </a>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5"> 5 </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10"> 10 </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20"> 20 </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 30"> 30 </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </template>

      <template slot="thead">
        <vs-th sort-key="name">{{$t(`ACCESTOKENS.user`)}}</vs-th>
        <vs-th sort-key="accessToken">{{$t(`ACCESTOKENS.token`)}}</vs-th>
        <vs-th sort-key="expireToken">
          <span>{{$t(`ACCESTOKENS.dateExpired`)}}</span>
          <vs-dropdown class="ml-3">
            <a class="flex items-center" href.prevent>
              <i class="material-icons"> filter_list </i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="option = 0"> {{$t(`ACCESTOKENS.tooltip.all`)}} </vs-dropdown-item>
              <vs-dropdown-item @click="option = 1"> {{$t(`ACCESTOKENS.tooltip.active`)}} </vs-dropdown-item>
              <vs-dropdown-item @click="option = 2"> {{$t(`ACCESTOKENS.tooltip.expired`)}} </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-th>
        <vs-th sort-key="companyName">{{$t(`ACCESTOKENS.company`)}}</vs-th>
        <vs-th>{{$t(`ACCESTOKENS.acctions`)}}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].name">
            <p>
              {{ data[indextr].name }}
            </p>
          </vs-td>

          <vs-td :data="data[indextr].accessToken">
            {{ data[indextr].accessToken }}
          </vs-td>

          <vs-td :data="data[indextr].expireToken">
            <span class="p-1 rounded font-bold" :class="stateDate(data[indextr].expireToken)">
              {{ data[indextr].expireToken | formatDate }}
            </span>
          </vs-td>

          <vs-td :data="data[indextr].companyName">
            {{ data[indextr].companyName }}
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <div class="flex justify-center">
              <vx-tooltip class="inline pl-2" :text="$t(`ACCESTOKENS.delete`)">
                <feather-icon
                  class="ml-2"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  @click="confirmDelete(data[indextr].accessToken)"
                />
              </vx-tooltip>

              <vx-tooltip class="inline pl-2" :text="$t(`ACCESTOKENS.edit`)">
                <feather-icon
                  class="ml-2"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  @click="editToken(tr)"
                />
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-popup id="calendar_expired" title="Actualizar fecha de expiración" :active.sync="popupActive">
      <vs-row>
        <vs-col class="px-1" vs-type="flex" vs-justify="center" vs-align="flex-end" vs-lg="6" vs-sm="12">
          <datepicker
            :disabledDates="disabledDates"
            v-model="dataToUpdate.expireAccount"
            :format="format"
            :inline="true"
            :language="languages[language]"
          ></datepicker>
        </vs-col>

        <vs-col class="px-1" vs-type="flex" vs-justify="center" vs-lg="6" vs-sm="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <vs-input disabled class="w-full" label="Token" placeholder="Token" v-model="dataToUpdate.token" />
            </vs-col>
            <vs-col vs-type="flex" vs-w="12">
              <vs-input disabled class="w-full" label="Usuario" placeholder="Usuario" v-model="dataToUpdate.user" />
            </vs-col>
            <vs-col vs-type="flex" vs-w="12">
              <vs-input
                disabled
                class="w-full"
                label="Comapañía"
                placeholder="Comapañía"
                v-model="dataToUpdate.company"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-w="12">
              <vs-input disabled class="w-full" label="Email" placeholder="Email" v-model="dataToUpdate.email" />
            </vs-col>
            <vs-col vs-type="flex" vs-w="12">
              <vs-button class="w-full" color="success" type="border" @click="updateToken">Actualizar</vs-button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import listTokens from "./mixins/listTokens";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import moment from "moment";
export default {
  mixins: [listTokens],
  components: { Datepicker },
  data() {
    return {
      language: "es",
      languages: lang
    };
  },
  methods: {
    stateDate(date) {
      const today = moment();
      const expired = moment(date);
      const diferent = expired.diff(today, "days");

      if (diferent <= 0) return "text-danger";
      if (diferent <= 4 && diferent >= 0) return "text-warning";
      return "text-success";
    }
  },
  mounted() {
    this.getTokens();
    this.getCompanies();
  }
};
</script>

<style lang="scss">
#listTokens {
  @import "@/assets/css/_themeTable.scss";
}

#calendar_expired .vdp-datepicker__calendar {
  width: 100%;
}
</style>
